import { Avatar, Box, Button, Card, CardContent, Divider, IconButton, MenuItem, Paper, Select, Typography } from '@mui/material'
import { useOrder, ORDER_TYPES } from 'context/OrderContext'
import React from 'react'
import ConfirmationDialog from "components/Modal/ConfirmationDialog/ConfirmationDialog"
import CustomButton from "components/Fileds/CustomButton"
import CustomTypography from 'components/Fileds/CustomTypography'
import CustomerInfoCard from 'components/CustomerInfoCard/CustomerInfoCard'
import OrderItemsContainer from 'components/OrderItems/OrderItems'
import OrderSuccessDialog from 'components/OrderSuccessDialog.js/OrderSuccessDialog'
import { useSelector } from 'react-redux'
import { formatCurrency } from 'utils/function'


const OrderPanelContainer = ({
    handleAddItem,
    handleRemoveItem,
    handleCreateOrder,
    successDialogOpen,
    orderID,
    handleConfirmCancel,
    handleOpenCancel,
    paymentMode,
    openCancelConfirm,
    setPaymentMode,
    handleCloseCancel,
    userData,
    isLoading,
    theme,
    orderType,
    customerData,
    orderItems,
    resetOrder,
    tax,
    platformFee,
    // discount,
    orderTotal,
    cartTotal,
    packageCharge,
    deliveryFee,
    setSuccessDialogOpen
}) => {
    const vendorData = useSelector((state) => state?.posData?.vendor);

    //   const paymentMethodOptions = [
    //     {label: "Cash", value: "cash"},
    //     {label: "Credit/Debit Card", value: "card"},
    //     {label: "Mobile Wallet", value: "mobilewallet"},
    //     {label: "Gift Card/Voucher", value: "gift_card_voucher"},
    //     {label: "Loyalty Points", value: "loyalty_points"},
    //   ]
    return (
        <Box className="cart-order-panel-container">
            {!successDialogOpen && (
                <Paper className='cart-order-details-cotainer'
                    elevation={0}
                >
                    {/* Header with title */}
                    <Box className='order-type-title'>
                        <CustomTypography
                            label={
                                orderType === ORDER_TYPES.TAKE_AWAY
                                    ? "Take Away Order"
                                    : orderType === ORDER_TYPES.DINE_IN
                                        ? "Dine-in Order"
                                        : orderType === ORDER_TYPES.PHONE_ORDER
                                            ? "Phone Order"
                                            : "Table Booking"
                            }
                            sx={{
                                fontWeight: 600, fontSize: '18px', mb: 0,
                                color: theme.palette.typographyLabel.main
                            }}
                        />
                    </Box>

                    {/* Customer info section */}
                    {customerData && (
                        <Box className='customer-info-card-box'>
                            <CustomerInfoCard
                                orderType={orderType}
                                customerData={customerData}
                            />
                        </Box>
                    )}
                    <Divider />

                    {/* Order items */}
                    <Box className='order-items-container'>
                        <OrderItemsContainer
                            orderItems={orderItems}
                            handleRemoveItem={handleRemoveItem}
                            handleAddItem={handleAddItem}
                            userData={userData}
                        />
                    </Box>


                    {/* Order summary - only show if there are items */}
                    {orderItems.length > 0 && (
                        <Box className='summary-order-item'>
                            <Box className='d-flex justify-content-between' sx={{ mb: 0.5 }}>
                                {/* <Typography variant="body1">Cart Total</Typography> */}
                                <CustomTypography
                                    variant={'body1'}
                                    label={"Cart Total"}
                                    sx={{ fontSize: '16px', fontWeight: 400, color: theme.palette.typographyLabel.main, mb: 0 }}
                                />
                                <CustomTypography
                                    variant={'body1'}
                                    label={formatCurrency(cartTotal.toFixed(2) || 0, userData.vendor.currency)}
                                    sx={{ fontSize: '16px', fontWeight: 400, color: theme.palette.typographyLabel.main, mb: 0 }}
                                />
                            </Box>
                            <Box className='d-flex justify-content-between' sx={{ mb: 0.5 }}>
                                <CustomTypography
                                    variant={"body2"}
                                    label={`Tax (${vendorData?.service_tax}%)`}
                                    sx={{ color: theme.palette.drawermenuitem.main, mb: 0, fontSize: '14px', fontWeight: 400 }}
                                />
                                <CustomTypography
                                    variant="body2"
                                    label={formatCurrency(tax.toFixed(2) || 0, userData.vendor.currency)}
                                    sx={{ color: theme.palette.drawermenuitem.main, mb: 0, fontSize: '14px', fontWeight: 400 }}
                                />
                            </Box>
                            {platformFee > 0 && (
                                <Box className='d-flex justify-content-between' sx={{ mb: 0.5 }}>
                                    <CustomTypography
                                        variant={"body2"}
                                        label={`Platform Fee (${vendorData?.platform_fee}%)`}
                                        sx={{ color: theme.palette.drawermenuitem.main, mb: 0, fontSize: '14px', fontWeight: 400 }}
                                    />
                                    <CustomTypography
                                        variant="body2"
                                        label={formatCurrency(platformFee.toFixed(2) || 0, userData.vendor.currency)}
                                        sx={{ color: theme.palette.drawermenuitem.main, mb: 0, fontSize: '14px', fontWeight: 400 }}
                                    />
                                </Box>
                            )}

                            {packageCharge > 0 && (
                                <Box className='d-flex justify-content-between' sx={{ mb: 0.5 }}>
                                    <CustomTypography
                                        variant={"body2"}
                                        label={"Package Charge"}
                                        sx={{ color: theme.palette.drawermenuitem.main, mb: 0, fontSize: '14px', fontWeight: 400 }}
                                    />
                                    <CustomTypography
                                        variant="body2"
                                        label={formatCurrency(packageCharge.toFixed(2) || 0, userData.vendor.currency)}
                                        sx={{ color: theme.palette.drawermenuitem.main, mb: 0, fontSize: '14px', fontWeight: 400 }}
                                    />
                                </Box>
                            )}

                            {deliveryFee > 0 && (
                                <Box className='d-flex justify-content-between' sx={{ mb: 0.5 }}>
                                    <CustomTypography
                                        variant={"body2"}
                                        label={"Delivery Fee"}
                                        sx={{ color: theme.palette.drawermenuitem.main, mb: 0, fontSize: '14px', fontWeight: 400 }}
                                    />
                                    <CustomTypography
                                        variant="body2"
                                        label={formatCurrency(deliveryFee.toFixed(2) || 0, userData.vendor.currency)}
                                        sx={{ color: theme.palette.drawermenuitem.main, mb: 0, fontSize: '14px', fontWeight: 400 }}
                                    />
                                </Box>
                            )}

                            {/* Discount for table booking */}
                            {/* {orderType === ORDER_TYPES.TABLE_BOOKING && (
                                <Box className='d-flex justify-content-between'
                                    sx={{ mb: 1}}
                                >
                                    <CustomTypography
                                        variant={"body2"}
                                        label={"Discount (10%)"}
                                        sx={{color: theme.palette.highlight.main, fontSize: "14px", fontWeight: 400, mb:0}}
                                    />
                                    <CustomTypography
                                        variant={"body2"}
                                        label={`-${discount.toFixed(2)}`}
                                        sx={{color: theme.palette.highlight.main, fontSize: "14px", fontWeight: 400, mb:0}}
                                    />
                                </Box>
                            )} */}
                            <Box className='d-flex justify-content-between'>
                                <CustomTypography
                                    variant={"body1"}
                                    label={"Order Total"}
                                    sx={{
                                        fontSize: '16px', fontWeight: 700,
                                        color: theme.palette.typographyLabel.main, mb: 0
                                    }}
                                />
                                <CustomTypography
                                    variant={"body1"}
                                    label={formatCurrency(orderTotal.toFixed(2) || 0, userData.vendor.currency)}
                                    sx={{
                                        fontSize: '16px', fontWeight: 700,
                                        color: theme.palette.typographyLabel.main, mb: 0
                                    }}
                                />
                            </Box>
                        </Box>
                    )}

                    {/* Payment mode - only show if there are items */}
                    {/* {orderItems.length > 0 && (
                        <Box className='d-flex align-items-center justify-content-between' sx={{ p: 2, paddingBottom:'0px' }}>
                            <CustomTypography
                                label={"Payment Mode"}
                                variant={"body1"}
                                sx={{fontWeight: 500, mb: 0, fontSize:'14px',
                                    color: theme.palette.typographyLabel.main
                                }}
                            />
                            <Select
                                value={paymentMode}
                                onChange={(e) => setPaymentMode(e.target.value)}
                                size="small"
                                sx={{
                                    minWidth: 150,
                                    ".MuiOutlinedInput-notchedOutline": {
                                        borderColor: "#e0e0e0",
                                    },
                                    borderRadius: 2,
                                }}
                            >
                                {paymentMethodOptions?.map((ele) => 
                                    <MenuItem value={ele.value}>{ele.label}</MenuItem>
                                )}
                            </Select>
                        </Box>
                    )} */}

                    {/* Action buttons - only show if there are items */}
                    <Box sx={{ p: 2, pt: "20px", display: "flex", gap: 1 }}>
                        {/* <Box className='d-flex justify-content-center'> */}
                        <CustomButton
                            variant="outlined"
                            fullWidth
                            sx={{
                                color: theme.palette.primary.main,
                                backgroundColor: 'transparent',
                                py: 2.8,
                                // mt: 1,
                                border: "1.5px solid #000",
                                fontSize: "14px",
                                borderRadius: '10px',
                                textTransform: 'none',
                                '&.Mui-disabled': {
                                    borderColor: 'rgba(0, 0, 0, 0.26)',
                                    color: 'rgba(0, 0, 0, 0.38)',
                                    backgroundColor: 'transparent',
                                    opacity: 0.6
                                }
                            }}
                            onClick={isLoading ? undefined : handleOpenCancel}

                        >
                            Cancel Order
                        </CustomButton>
                        {/* </Box> */}
                        <CustomButton
                            variant="contained"
                            fullWidth
                            sx={{
                                py: 3,
                                borderRadius: '10px',
                                fontSize: "18px",
                                fontWeight: 600,
                                textTransform: 'none'
                            }}
                            onClick={handleCreateOrder}
                            loading={isLoading}
                            disabled={orderItems?.length === 0}
                        >
                            Create Order
                        </CustomButton>
                    </Box>
                </Paper>
            )}
            <ConfirmationDialog
                open={openCancelConfirm}
                handleClose={handleCloseCancel}
                handleConfirm={handleConfirmCancel}
                isLoading={isLoading}
                action="Cancel Order"
                btnText="Cancel Order"
                infoText="Are you sure you want to cancel your order?"
            />
            {/* Order Success Dialog */}
            <OrderSuccessDialog
                open={successDialogOpen}
                id={orderID}
                onClose={() => {
                    setSuccessDialogOpen(false)
                    resetOrder() // Reset order after closing success dialog
                }}
            />
        </Box>
    )
}

export default OrderPanelContainer
